import React from "react";
import { Redirect } from "react-router-dom";
import { default as debugLog, LOG_TYPE } from "../../utility/logger";

const SignInPage = props => {
  debugLog("authProps", LOG_TYPE.Log, props.authProps);

  if (props.authProps.isAuthenticated && props.authProps.user) {
    return <Redirect to="/" />;
  } else {
    return null;
  }
};

export default SignInPage;
